import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { history } from "./lib/history";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 720,
      margin: "0 auto",
      padding: theme.spacing(4, 3, 8),
    },
    title: {
      fontWeight: 700,
      marginBottom: theme.spacing(2),
    },
    heading: {
      fontWeight: 700,
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1),
    },
    body: {
      marginBottom: theme.spacing(1),
      lineHeight: 1.6,
    },
    back: {
      marginBottom: theme.spacing(3),
    },
  });

type PrivacyProps = WithStyles<typeof styles>;

const PrivacyUnstyled: React.FunctionComponent<PrivacyProps> = ({ classes }) => {
  return (
    <div className={classes.root}>
      <Button className={classes.back} color="primary" onClick={() => history.push("/login")}>
        Back to login
      </Button>
      <Typography variant="h4" className={classes.title}>
        Impala QC Privacy Policy
      </Typography>
      <Typography className={classes.body}>
        Impala QC is a mobile quality-control app for authorised Impala Citrus staff.
      </Typography>
      <Typography variant="h6" className={classes.heading}>
        Data we collect
      </Typography>
      <Typography className={classes.body}>
        Account identifiers (username / user ID) when you log in. Inspection records, comments, and related work data.
        Photos you take or choose for inspections.
      </Typography>
      <Typography variant="h6" className={classes.heading}>
        How we use it
      </Typography>
      <Typography className={classes.body}>
        We use this data only to operate Impala QC: authenticate users, save and sync inspections, and run Impala’s
        quality-control process. We do not use it for advertising, tracking, or sale to data brokers.
      </Typography>
      <Typography variant="h6" className={classes.heading}>
        Where it is stored
      </Typography>
      <Typography className={classes.body}>
        Data is sent to Impala Citrus systems and stored for as long as needed for quality control and business records.
      </Typography>
      <Typography variant="h6" className={classes.heading}>
        Sharing
      </Typography>
      <Typography className={classes.body}>
        We do not share this data with advertising networks or analytics SDKs. It is available to Impala staff and
        systems that need it to run the business.
      </Typography>
      <Typography variant="h6" className={classes.heading}>
        Contact
      </Typography>
      <Typography className={classes.body}>
        Impala Citrus
        <br />
        info@impalacitrus.co.za
        <br />
        +27 (0) 21 110 0900
        <br />
        https://www.impalacitrus.co.za/contact-us/
      </Typography>
    </div>
  );
};

export const Privacy = withStyles(styles)(PrivacyUnstyled);
export default Privacy;
